import { ApiService } from 'src/app/services/api.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MedicalCenterService {

    public medicalCenterID: Observable<number>;
    private data: any;
    private medicalCenterIDSubject: BehaviorSubject<number>;

    constructor(
      private localStorage: LocalStorageService,
      private api$: ApiService,
      private router: Router
    ) {
      let medicalCenter = this.localStorage.retrieve('selectedMedCenter');
      if (!medicalCenter && medicalCenter !== 0) {
        medicalCenter = this.localStorage.retrieve('loggedUser')?.userMedicalCenter.MedicalCenterID;
      }
      this.medicalCenterIDSubject = new BehaviorSubject<number>(medicalCenter);
      this.medicalCenterID = this.medicalCenterIDSubject.asObservable();
    }

    public getMedicalCenters(fromCache = true): Observable<any> {
      const data = this.localStorage.retrieve('medical-centers');
      if (fromCache === false || !data) {
        return this.api$.getMedicalCentersList().map(data => {
          if (data.success == true) {
            this.data = data.data;
            this.localStorage.store('medical-centers', data.data);
            const medicalCenter = this.localStorage.retrieve('selectedMedCenter');
            if (medicalCenter > 0 ) {
              const findMedCenter = data.data.find(x => x.MedicalCenterID == medicalCenter);
              if (!findMedCenter) {
                const medicalCenter = this.localStorage.retrieve('loggedUser')?.userMedicalCenter.MedicalCenterID;
                this.setMedicalCenterID(medicalCenter);
              }
            } else if (medicalCenter == 0 && data.data.length == 1) {
              const medicalCenter = this.localStorage.retrieve('loggedUser')?.userMedicalCenter.MedicalCenterID;
              if (data.data.find(x => x.MedicalCenterID == medicalCenter)) {
                this.setMedicalCenterID(medicalCenter);
              }
            }
            return data.data;
          }

        });
      } else {
        this.data = data;
        return of(data);
      }
    }

    public getMedicalCenterID() {
      return this.medicalCenterIDSubject.getValue();
    }

    public getRequiredMedicalCenterID() {
      if (this.router.url.startsWith('/screen/black-screen') || this.router.url.startsWith('/screen/black-single-screen') || this.router.url.startsWith('/screen/ext-patient')) {
        const medicalCenterID = this.getSelectedMedicalCenterBlack();
        if (medicalCenterID && medicalCenterID > 0) {
          return medicalCenterID;
        }
      }
      return this.getMedicalCenterID() > 0 ? this.getMedicalCenterID() : this.localStorage.retrieve('loggedUser')?.userMedicalCenter.MedicalCenterID;
    }


    public setMedicalCenterID(medicalCenterID: number) {

      if (!medicalCenterID) {
        medicalCenterID = 0;
      }
      this.medicalCenterIDSubject.next(medicalCenterID);
      this.localStorage.store('selectedMedCenter', medicalCenterID);
    }
    public getMedicalCenterByID(id: number) {
      if (!this.data) {
        this.data = this.localStorage.retrieve('medical-centers');
      }
      return this.data.find(x => x.MedicalCenterID === id)?.MedicalCenterName;
    }

    public getMedicalCenterByExternalID(externalId: string) {
      if (!this.data) {
        this.data = this.localStorage.retrieve('medical-centers');
      }
      return this.data?.find(x => x.MedicalCenterExternalID === externalId);
    }

    public async getMedicalCenterByExternalIDWithRetry(externalId: string) {
      const medicalCenter = this.getMedicalCenterByExternalID(externalId);
      if (!medicalCenter) {
        await this.getMedicalCenters(true).toPromise();
        return this.getMedicalCenterByExternalID(externalId);
      }
      return medicalCenter;
    }

    public getSelectedMedicalCenterBlack() {

      const medicalCenter = this.localStorage.retrieve('selectedMedCenterBlack');
      if (medicalCenter && medicalCenter > 0) {
        return medicalCenter;
      } else {
        const loggedUser = this.localStorage.retrieve('loggedUser');
        if (loggedUser && loggedUser.userMedicalCenter) {
          return loggedUser.userMedicalCenter.MedicalCenterID;
        }
      }
      return '';
    }

    public getLoggedUserDefaultMedicalCenter() {
      const loggedUser = this.localStorage.retrieve('loggedUser');
      if (loggedUser && loggedUser.userMedicalCenter) {
        return loggedUser.userMedicalCenter.MedicalCenterID;
      }
      return 0;
    }
    
    public setSelectedMedicalCenterBlack(medicalCenterID: number) {
      if (!medicalCenterID) {
        medicalCenterID = 0;
      }
      this.localStorage.store('selectedMedCenterBlack', medicalCenterID);
      
    }
}